// extracted by mini-css-extract-plugin
module.exports = {"hidden":"tab_hidden__sfFVo","textEmphasis":"tab_textEmphasis__eRWPK","tabWrap":"tab_tabWrap__sibwu","tabTitle":"tab_tabTitle__jE_Vx","active":"tab_active__AgrBu"};